import { P0, S, abs, earShape, fillAt, lerp, max, sq } from '../../geometry';

export const owl = {
  name: 'Owl',
  colors: ['#3E63DD', '#E3A008'],
  draw(m, t) {
    let turn = 1.2 * S(t * 0.7),
      tu = 0,
      wL = 4 * S(t * 1.6),
      wR = 4 * S(t * 1.6 + 0.8),
      hh = 24,
      pose = P0();
    if (m === 'happy') {
      wL = wR = 10 + 24 * abs(S(t * 9));
      tu = 2;
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the head keeps swivelling side to side, eyes and tufts turning with it.
    if (m === 'thinking') {
      turn = 8 * S(t * 1.5);
      tu = 1.5 * S(t * 3);
      wL = 8 * max(0, S(t * 1.5));
      wR = 8 * max(0, -S(t * 1.5));
    }
    if (m === 'talking') tu = 2.5 * max(0, S(t * 10));
    if (m === 'surprised') {
      tu = 6;
      hh = 26;
      wL = wR = 40 + 3 * S(t * 24);
      pose.ty = -2;
    }
    if (m === 'paused') {
      tu = -5;
      hh = 21;
      turn = 0;
      wL = wR = -3;
      pose.ty = 1;
    }
    const cy = 83 - hh,
      top = 83 - 2 * hh,
      low = sq(50, cy + 2, 23, hh - 2, 2.4, 24).slice(6, 19);
    const tip = (p, a, b) => [
      [lerp(a[0], p[0], 0.8), lerp(a[1], p[1], 0.8)],
      p,
      [lerp(b[0], p[0], 0.8), lerp(b[1], p[1], 0.8)],
    ];
    const tL = [30 + turn, top - 2 - tu],
      tR = [70 + turn, top - 2 - tu],
      iL = [40 + turn * 0.7, top + 4],
      iR = [60 + turn * 0.7, top + 4];
    const head = [
      ...low,
      [29, top + 14],
      ...tip(tL, [29, top + 14], iL),
      [50 + turn * 0.8, top + 6],
      ...tip(tR, iR, [71, top + 14]),
      [71, top + 14],
      low[0],
    ];
    const wing = (dir, w) =>
      earShape(50 + dir * 19, cy - 6, dir * (165 - w), dir * -14, 20, 5.5)
        .outline;
    return {
      strokes: [
        {
          c: 'b',
          pts: [
            [19, 89],
            [50, 88],
            [83, 90],
          ],
        },
        {
          c: 'b',
          pts: [
            [43, 82],
            [42, 89],
          ],
        },
        {
          c: 'b',
          pts: [
            [57, 82],
            [58, 89],
          ],
        },
        { c: 'b', pts: wing(-1, wL), n: 22 },
        { c: 'b', pts: wing(1, wR), n: 22 },
        { c: 'a', pts: head, n: 48 },
      ],
      eyes: { x: 50 + turn, y: top + 19 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 3, 4, 5),
};
